import { AwardType } from '@occc-app/offerHelpers/types';

import { GeneralSurveyConfigureFormInitialValues } from './components/ConfigureForm/types';
import { GeneralSurveyTargetFormInitialValues } from './components/TargetForm/types';
import { GeneralSurveyScheduleFormInitialValues } from './components/ScheduleForm/types';

export const configureFormInitialValues: GeneralSurveyConfigureFormInitialValues = {
  questionType: 'SurveyQuestionSingleChoice',
  name: '',
  description: '',
  question: '',
  options: ['', ''],
  incentivizeResponses: {
    isEnabled: true,
    awardType: AwardType.AwardPoints,
    awardPoints: undefined,
    awardVouchers: undefined,
  },
};

export const targetFormInitialValues: GeneralSurveyTargetFormInitialValues = {};

export const scheduleFormInitialValues: GeneralSurveyScheduleFormInitialValues = {};
